"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const stateFunctions = __importStar(require("../../domain/stateFunctions"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const chatListItemBuilder = __importStar(require("./ChatListItemBuilder"));
const MessageSearchMatch_1 = __importDefault(require("./MessageSearchMatch"));
const service_1 = __importDefault(require("../../services/chats/service"));
const useStyles = makeStyles_1.default((theme) => ({
    searchResults: {
        overflow: "auto"
    },
    groupTitle: {
        padding: "4px 16px"
    }
}));
exports.default = react_1.default.memo(SearchResults);
function SearchResults(props) {
    var _a;
    const chats = react_redux_1.useSelector((state) => state.chatsState.chats);
    const me = (_a = react_redux_1.useSelector((state) => { var _a; return (_a = state.usersState.me) === null || _a === void 0 ? void 0 : _a.userId; })) !== null && _a !== void 0 ? _a : "";
    const userDictionary = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    const [messageMatches, setMessageMatches] = react_1.useState([]);
    const getUser = (userId) => stateFunctions.getUserSummary(userId, userDictionary);
    const chatMatches = searchChats(chats, props.searchTerm, getUser);
    react_1.useEffect(() => {
        // search messages
        service_1.default
            .searchAllMessages(props.searchTerm, 20)
            .then((res) => {
            if (res.kind === "success") {
                const matches = res.result.matches;
                setMessageMatches(matches);
            }
        });
    }, [props.searchTerm]);
    const classes = useStyles();
    function createGroup(title, items) {
        return (react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Box_1.default, { className: classes.groupTitle }, title),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(List_1.default, { disablePadding: true }, items)));
    }
    const groups = [];
    if (chatMatches.length) {
        groups.push(createGroup("Chats", chatMatches.map(([chat, index]) => chatListItemBuilder.build(chat, userDictionary, index, null, me))));
    }
    if (messageMatches.length) {
        groups.push(createGroup("Messages", messageMatches.map(m => react_1.default.createElement(MessageSearchMatch_1.default, { key: `${m.chatId}_${m.message.id}`, chatId: m.chatId, message: m.message, searchTerm: props.searchTerm }))));
    }
    return (react_1.default.createElement(Grid_1.default, { container: true, direction: "column", wrap: "nowrap", className: classes.searchResults }, groups));
}
function searchChats(chats, searchTerm, getUser) {
    searchTerm = searchTerm.toLowerCase();
    const matches = [];
    for (let index = 0; index < chats.length; index++) {
        const chat = chats[index];
        if (chatFunctions.isDirectChat(chat)) {
            const user = getUser(chat.them);
            if (user && user.username.toLowerCase().indexOf(searchTerm) >= 0) {
                matches.push([chat, index]);
            }
        }
        else if (chat.subject.toLowerCase().indexOf(searchTerm) >= 0) {
            matches.push([chat, index]);
        }
    }
    return matches;
}
function searchUsers(users, searchTerm) {
    searchTerm = searchTerm.toLowerCase();
    return users.filter(u => u.username.toLowerCase().indexOf(searchTerm) >= 0);
}
function getUsersWithoutDirectChats(users, chats) {
    const usersWithDirectChats = new Set();
    for (const chat of chats.filter(chatFunctions.isDirectChat)) {
        usersWithDirectChats.add(chat.them);
    }
    return users.filter(u => !usersWithDirectChats.has(u.userId));
}
